export default "__VITE_ASSET__r02be32w__"